module.exports = __webpack_public_path__ + "static/media/community-gardens-gallery-8-sm.c63a8ed4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/community-gardens-gallery-8-sm.jpg
// module id = 150
// module chunks = 12